<ax-drawer-container class="fixed-container" #dc>
    <ax-drawer #d mode="overlay" location="end" [collapsed]="true" class="ax-w-72">
        <ax-content> <travel-btc-workspace-drawer-menu></travel-btc-workspace-drawer-menu></ax-content>
    </ax-drawer>
    <ax-content class="!ax-overflow-hidden">
        <div class="ax-overflow-auto ax-w-full ax-h-full" #div>
            <travel-btc-workspace-hotel-wl-header></travel-btc-workspace-hotel-wl-header>
            <router-outlet></router-outlet>
            <travel-btc-workspace-hotel-wl-footer></travel-btc-workspace-hotel-wl-footer>
        </div>
    </ax-content>
</ax-drawer-container>